import { render, staticRenderFns } from "./Mywallet.vue?vue&type=template&id=287b4220&scoped=true&"
import script from "./Mywallet.vue?vue&type=script&lang=js&"
export * from "./Mywallet.vue?vue&type=script&lang=js&"
import style0 from "./Mywallet.vue?vue&type=style&index=0&id=287b4220&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b4220",
  null
  
)

export default component.exports